import graphqlClient from '../../api/axios_interceptor';
import { AddUnitMutation, DeleteUnitMutation, GetAllPropertiesUnitsQuery, UpdateUnitMutation } from '../../api/graphql/queries/unit';
import {
    ADD_UNIT, UPDATE_UNIT, DELETE_UNIT, LOAD_UNITS, LOAD_PROPERTIES
} from '../actions/actionTypes';
import { fetchTenants } from './tenants';
import { updateActionErrors } from './updateErrors';

const parseUnit = (unit) => ({
    propertyId: unit.property.id,
    unitName: unit.unitName,
    unitId: unit.id,
    rentAmount: unit.rentAmount,
    occupied: unit.occupied,
    taxRate: unit.taxRate || 0,
    otherRecurringBillsItems: unit.otherRecurringBills ? JSON.parse(JSON.parse(unit.otherRecurringBills)) : [],
    notes: unit.notes
})

const unitsMiddleware = storeAPI => next => async action => {
    let unit = action.payload

    switch (action.type) {
        case ADD_UNIT:
            // TODO: API call to add unit
            try {

                await graphqlClient({
                    data: {
                        query: AddUnitMutation(unit.propertyId, unit.unitName, unit.rentAmount, 
                            unit.occupied, unit.taxRate, unit.otherRecurringBillsItems,  unit.notes)
                    }
                }).then((queryResult) => {
                    if (queryResult.data.errors) {
                        action = updateActionErrors(action, queryResult.data.errors);
                    }else if(queryResult.data.data.addUnit.errorMessage){
                        action = updateActionErrors(action, queryResult.data.data.addUnit.errorMessage);
                    } else {
                        let modPayload = {
                            ...action.payload,
                            unitId: queryResult.data.data.addUnit.unit.id
                        }

                        action = {
                            ...action,
                            payload: modPayload
                        };
                    }

                });
            } catch (error) {
                console.error(error);
                action = updateActionErrors(action, error)
            }
            break;
        case UPDATE_UNIT:
            // TODO: API call to update unit
            try {
                await graphqlClient({
                    
                    data: {
                        query: UpdateUnitMutation(unit.propertyId, unit.unitId, unit.unitName, unit.rentAmount, 
                            unit.occupied, unit.taxRate, unit.otherRecurringBillsItems, unit.notes)
                    }

                }).then((queryResult) => {
                    if (queryResult.data.errors) {
                        action = updateActionErrors(action, queryResult.data.errors);
                    }
                });
            } catch (error) {
                console.error(error);
                action = updateActionErrors(action, error)
            }
            break;
        case DELETE_UNIT:
            // TODO: API call to delete unit
            try {

                await graphqlClient({
                    data: {
                        query: DeleteUnitMutation(unit.unitId)
                    }
                }).then((queryResult) => {
                    if (queryResult.data.errors) {
                        action = updateActionErrors(action, queryResult.data.errors);
                    } else if (queryResult.data.data.deleteUnit.success === 'false') {
                        let error = 'Failed to delete a unit associated with a tenant';
                        action = updateActionErrors(action, error);
                    }
                });
            } catch (error) {
                console.error(error);
                action = updateActionErrors(action, error);
            }
            break;
        case LOAD_UNITS:
            try{
                await graphqlClient({
                    data: {
                        query: GetAllPropertiesUnitsQuery(action.payload.propertyIds)
                    }
                }).then((queryResult) => {
                    if (queryResult.data.errors) {
                        action = updateActionErrors(action, queryResult.data.errors);
                    } else {
                        let units = {};
                        queryResult.data.data.propertiesUnits.map((unit) => (
                            units[unit.id] = { ...parseUnit(unit) }
                        ))

                        let initialData = { units };
                        action = { type: LOAD_UNITS, payload: initialData };
                    }
                });

            } catch(error) {
                console.error(error);
                action = updateActionErrors(action, error);
            }
            break;
    }

    return next(action);
};

async function fetchUnits(dispatch, getState) {
    // todo: load data from backend instead of using fake data

    let units = {};
    let units_data = {}
    //create the list of properties and pass it to the query function
    let propertyIDs = [];
    let storedProperties = getState().properties

    for (const element of Object.keys(storedProperties)) {
        propertyIDs.push(String(element));
    }


    try {
        await graphqlClient({
            data: {
                query: GetAllPropertiesUnitsQuery(propertyIDs)
            }
        }).then((queryResult) => {
            queryResult.data.data.propertiesUnits.map((unit) => (
                units[unit.id] = { ...parseUnit(unit) }
            ))

            let initialData = { units };
            dispatch({ type: LOAD_UNITS, payload: initialData });

        }).then(() => {
            let properties = { ...storedProperties };

            for (const [key, value] of Object.entries(units)) {
                properties[value.propertyId]["units"][value.unitId] = {}
            }

            dispatch({ type: LOAD_PROPERTIES, payload: { properties } });
        }).then(() => {
            fetchTenants(dispatch, getState);
        });
    } catch (error) {
        console.error(error);
    }

}

export {
    unitsMiddleware,
    fetchUnits,
    parseUnit
}